<script lang="ts">
import {Toast} from "flowbite-svelte";
import {globalToast} from "$lib/stores/toast";
import {fly} from "svelte/transition";


</script>

<Toast bind:open={$globalToast.open} dismissable={true} color={$globalToast.color} position="top-right" class="z-50" transition={fly} >
    <div class="flex gap-3">
        {#if $globalToast.icon}
            <svelte:component this={$globalToast.icon} />
        {/if}
        <div>
            {$globalToast.content}
        </div>
    </div>

</Toast>